import { useI18n } from 'next-localization';

export const Alert = (): JSX.Element => {
  const { t } = useI18n();
  return (
    <div className="p-2 neu-bg-blue-10 neu-text-blue-80 mb-3" role="alert" aria-live="polite">
      <strong>{t('OAS.Booking.Appointment.AlertTextStrong')}</strong>
      {t('OAS.Booking.Appointment.AlertText')}
    </div>
  );
};
